/**
 * Iniciales del avatar del menú de perfil.
 *
 * Vive fuera de `UserProfileContent.jsx` para no mezclar utilidades con componentes en el mismo
 * archivo (`react-refresh/only-export-components`).
 *
 * @param {string} nombre - Nombre, o el nombre completo concatenado cuando no hay apellido
 * @param {string} apellido - Apellido (puede venir vacío)
 * @returns {string} Una o dos iniciales en mayúsculas
 */
export const getIniciales = (nombre, apellido) => {
  // Comportamiento actual: inicial del nombre + inicial del apellido
  if (apellido?.trim()) {
    const inicialNombre = nombre?.trim().charAt(0).toUpperCase() || ''
    return `${inicialNombre}${apellido.trim().charAt(0).toUpperCase()}`
  }

  // Fallback (nombreConcatenado): inicial de cada palabra del nombre, ej. "Juan Pérez" → "JP"
  return (nombre || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((palabra) => palabra.charAt(0).toUpperCase())
    .slice(0, 2)
    .join('')
}
